
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ejar-contracts",
      function () {
        return require("private-next-pages/ejar-contracts/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ejar-contracts"])
      });
    }
  